import { withCompInfo } from '@wix/editor-elements-integrations'
import { colorApi } from '@wix/thunderbolt-becky-root'
import { marginsToCss, sizeToString } from '@wix/thunderbolt-commons'
import type { FooterContainerCSSVars, FooterContainerDefinition } from './FooterContainer'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'
import { omitBy } from 'lodash'
import type { MasterPageItemLayout } from '@wix/thunderbolt-becky-types'

export const css = withCompInfo<FooterContainerCSSVars, FooterContainerDefinition>()(
	[
		'styleProperties',
		'compLayout',
		'siteColors',
		'compSingleLayout',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'viewMode',
		'compId',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
		'isOneDocMigrated',
	],
	({
		styleProperties,
		compLayout,
		siteColors,
		compSingleLayout,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		viewMode,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
		isOneDocMigrated,
	}) => {
		const backgroundMedia = compDesign?.background || {}

		const fillLayers = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compDesign,
			compProps,
			compId,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})

		const brightnessParams = colorApi.getBrightnessCSSVars({
			siteColors,
			styleProperties,
		})

		const itemLayout = compSingleLayout?.itemLayout as MasterPageItemLayout
		const emptySize = sizeToString(null)

		const style =
			(!isOneDocMigrated &&
				compLayout.fixedPosition && {
				position: 'sticky !important' as const,
				bottom: '0' as const,
			}) ||
			(isOneDocMigrated &&
				omitBy(
					{
						position: itemLayout?.isFixed ? 'sticky' : 'relative',
						top: sizeToString(itemLayout?.top),
						bottom: sizeToString(itemLayout?.bottom),
						left: sizeToString(itemLayout?.left),
						right: sizeToString(itemLayout?.right),
						...marginsToCss(itemLayout?.margins),
					},
					(value) => value === emptySize
				))

		return {
			...brightnessParams,
			...style,
			...fillLayers,
		}
	}
)
